import { Action, Actions, State, StateContext, Store } from '@ngxs/store';
import { IBrickSettingStateModel, SpecificBrickSettingsStateBase } from '../specific-brick-settings-base';
import { BrickSettingsService, UserStatusBrickSettingRemoteDto } from '../../../../../../../generated/swagger';
import _ from 'lodash';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import {
   ChangeShowAlternativeDeviceEditor,
   ChangeShowAvatar,
   ChangeShowBackgroundImage,
   ChangeShowPrivateDn,
   ChangeShowStatusDropdown,
   ChangeShowUsername,
} from './user-status-brick-settings.actions';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';

export interface UserStatusBrickSettingsStateModel extends IBrickSettingStateModel<UserStatusBrickSettingRemoteDto> {}

function getDefaultSpecificBrickSetting(): UserStatusBrickSettingRemoteDto {
   return {
      showBackgroundImage: true,
      showUsername: true,
      showPrivateDn: true,
      showAlternativeDeviceEditor: true,
      showAvatar: true,
      showStatusDropdown: true,
      commonBrickSettingRemoteDto: null,
   };
}

@State<UserStatusBrickSettingsStateModel>({
   name: 'userStatusBrickSettings',
   defaults: {
      specificBrickSettings: {
         brickSettings: {},
         brickSettingsEditMode: null,
      },
   },
})
@Injectable()
export class UserStatusBrickSettingsState extends SpecificBrickSettingsStateBase<UserStatusBrickSettingRemoteDto>(getDefaultSpecificBrickSetting) {
   constructor(private brickSettingsService: BrickSettingsService, store: Store, actions$: Actions) {
      super(store);
   }

   @Action(ChangeShowBackgroundImage)
   @ImmutableContext()
   public changeShowBackgroundImage(ctx: StateContext<UserStatusBrickSettingsStateModel>, action: ChangeShowBackgroundImage) {
      ctx.setState((state: UserStatusBrickSettingsStateModel) => {
         const brickSettingModel = UserStatusBrickSettingsState.getSettingModelOrDefault(state, action.brickInstanceId);
         brickSettingModel.showBackgroundImage = action.show;
         state.specificBrickSettings.brickSettingsEditMode[action.brickInstanceId] = brickSettingModel;
         return state;
      });
   }

   @Action(ChangeShowUsername)
   @ImmutableContext()
   public changeShowUsername(ctx: StateContext<UserStatusBrickSettingsStateModel>, action: ChangeShowUsername) {
      ctx.setState((state: UserStatusBrickSettingsStateModel) => {
         const brickSettingModel = UserStatusBrickSettingsState.getSettingModelOrDefault(state, action.brickInstanceId);
         brickSettingModel.showUsername = action.show;
         state.specificBrickSettings.brickSettingsEditMode[action.brickInstanceId] = brickSettingModel;
         return state;
      });
   }

   @Action(ChangeShowPrivateDn)
   @ImmutableContext()
   public changeShowPrivateDn(ctx: StateContext<UserStatusBrickSettingsStateModel>, action: ChangeShowPrivateDn) {
      ctx.setState((state: UserStatusBrickSettingsStateModel) => {
         const brickSettingModel = UserStatusBrickSettingsState.getSettingModelOrDefault(state, action.brickInstanceId);
         brickSettingModel.showPrivateDn = action.show;
         state.specificBrickSettings.brickSettingsEditMode[action.brickInstanceId] = brickSettingModel;
         return state;
      });
   }

   @Action(ChangeShowAvatar)
   @ImmutableContext()
   public changeShowAvatar(ctx: StateContext<UserStatusBrickSettingsStateModel>, action: ChangeShowAvatar) {
      ctx.setState((state: UserStatusBrickSettingsStateModel) => {
         const brickSettingModel = UserStatusBrickSettingsState.getSettingModelOrDefault(state, action.brickInstanceId);
         brickSettingModel.showAvatar = action.show;
         state.specificBrickSettings.brickSettingsEditMode[action.brickInstanceId] = brickSettingModel;
         return state;
      });
   }

   @Action(ChangeShowAlternativeDeviceEditor)
   @ImmutableContext()
   public changeShowAlternativeDeviceEditor(ctx: StateContext<UserStatusBrickSettingsStateModel>, action: ChangeShowAlternativeDeviceEditor) {
      ctx.setState((state: UserStatusBrickSettingsStateModel) => {
         const brickSettingModel = UserStatusBrickSettingsState.getSettingModelOrDefault(state, action.brickInstanceId);
         brickSettingModel.showAlternativeDeviceEditor = action.show;
         state.specificBrickSettings.brickSettingsEditMode[action.brickInstanceId] = brickSettingModel;
         return state;
      });
   }

   @Action(ChangeShowStatusDropdown)
   @ImmutableContext()
   public changeShowStatusDropdown(ctx: StateContext<UserStatusBrickSettingsStateModel>, action: ChangeShowStatusDropdown) {
      ctx.setState((state: UserStatusBrickSettingsStateModel) => {
         const brickSettingModel = UserStatusBrickSettingsState.getSettingModelOrDefault(state, action.brickInstanceId);
         brickSettingModel.showStatusDropdown = action.show;
         state.specificBrickSettings.brickSettingsEditMode[action.brickInstanceId] = brickSettingModel;
         return state;
      });
   }

   protected doSaveSpecificSettings(brickInstanceId: string, brickSetting: UserStatusBrickSettingRemoteDto): Observable<any> {
      return this.brickSettingsService.changeUserStatusBrickSettings({
         brickInstanceId: brickInstanceId,
         settings: brickSetting,
      });
   }
}
